import React from "react";

interface ContentAreaProps {
  children: React.ReactNode;
}

/**
 * ContentArea component for displaying the main content
 */
export const ContentArea: React.FC<ContentAreaProps> = ({ children }) => {
  return <div className="flex-grow overflow-auto p-4 relative">{children}</div>;
};
